import { jsx as _jsx } from "preact/jsx-runtime";
import { CalendarApi, CalendarContent, CalendarDataProvider, CalendarRoot } from "@fullcalendar/core";
import { Component } from "preact";
export class PreactFullCalendar extends Component {
    constructor(props) {
        super(props);
        this._calendarApi = new CalendarApi();
    }
    render() {
        return (_jsx(CalendarDataProvider, Object.assign({ optionOverrides: this.props, calendarApi: this._calendarApi }, { children: (data) => (_jsx(CalendarRoot, Object.assign({ options: data.calendarOptions, theme: data.theme, emitter: data.emitter }, { children: (classNames, height, isHeightAuto, forPrint) => (_jsx("div", Object.assign({ className: classNames.join(' '), style: { height } }, { children: _jsx(CalendarContent, Object.assign({ isHeightAuto: isHeightAuto, forPrint: forPrint }, data), void 0) }), void 0)) }), void 0)) }), void 0));
    }
}
